export const stock = {
	title: "STOCK",
	fields: {
		isStockable: {
			label: "¿Producto en stock?",
			placeholder: "Sí",
			tooltip:
				"Los productos almacenables son aquellos que se guardan en inventario hasta que se venden o usan.",
			options: {
				yes: "Sí",
				no: "No",
			},
		},
		stockControlledBy: {
			label: "Stock controlado por:",
			placeholder: "Unidades",
			options: {
				gram: "Gramos",
				kilogram: "Kilogramos",
				liter: "Litros",
				milliliter: "Mililitros",
				unit: "Unidades",
			},
		},
		conversionRule: {
			label: "Regla de conversión",
			tooltip:
				"Define cómo las unidades de venta se convierten a unidades de stock. Ej: 1 botella = 1 litro",
			unitLabel: "1 unidad",
			equivalentTo: "equivale a:",
		},
		conversionQuantity: {
			label: "Cantidad",
			placeholder: "750",
		},
		conversionUnit: {
			label: "Unidad de medida",
			placeholder: "Mililitros",
			options: {
				gram: "Gramos",
				kilogram: "Kilogramos",
				liter: "Litros",
				milliliter: "Mililitros",
			},
		},
	},
	messages: {
		nonStockableWarning:
			"Los productos no almacenables <strong>no aparecerán en los informes de stock</strong>",
	},
};
